var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vacancy-detail container" }, [
    _c(
      "div",
      { staticClass: "vacancy-detail__container" },
      [
        _c(
          "z-link",
          {
            staticClass: "vacancy-detail__link",
            attrs: {
              size: "m",
              iconPosition: "left",
              icon: "arrow",
              href: _vm.nav["back-link"],
            },
          },
          [_vm._v(_vm._s(_vm.text.linkText))]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("section", [
      _c("div", { staticClass: "vacancy-detail__hero" }, [
        _c("div", { staticClass: "vacancy-detail__hero-item-container" }, [
          _vm.vacancyData.money && _vm.vacancyData.money.value
            ? _c(
                "div",
                { staticClass: "vacancy-detail__hero-item" },
                [
                  _c(
                    "z-caption",
                    {
                      staticClass: "vacancy-detail__hero-title",
                      attrs: { tag: "p" },
                    },
                    [_vm._v(_vm._s(_vm.text.money))]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-caption",
                    {
                      staticClass: "vacancy-detail__hero-text",
                      attrs: { tag: "p" },
                    },
                    [_vm._v(_vm._s(_vm.vacancyData.money.value))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.vacancyData.city && _vm.vacancyData.city.value
            ? _c(
                "div",
                { staticClass: "vacancy-detail__hero-item" },
                [
                  _c(
                    "z-caption",
                    {
                      staticClass: "vacancy-detail__hero-title",
                      attrs: { tag: "p" },
                    },
                    [_vm._v(_vm._s(_vm.text.filters.city))]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-caption",
                    {
                      staticClass: "vacancy-detail__hero-text",
                      attrs: { tag: "p" },
                    },
                    [_vm._v(_vm._s(_vm.vacancyData.city.value))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.vacancyData.type && _vm.vacancyData.type.value
            ? _c(
                "div",
                { staticClass: "vacancy-detail__hero-item" },
                [
                  _c(
                    "z-caption",
                    {
                      staticClass: "vacancy-detail__hero-title",
                      attrs: { tag: "p" },
                    },
                    [_vm._v(_vm._s(_vm.text.filters.jobType))]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-caption",
                    {
                      staticClass: "vacancy-detail__hero-text",
                      attrs: { tag: "p" },
                    },
                    [_vm._v(_vm._s(_vm.vacancyData.type.value))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.vacancyData.specialization && _vm.vacancyData.specialization.value
            ? _c(
                "div",
                { staticClass: "vacancy-detail__hero-item" },
                [
                  _c(
                    "z-caption",
                    {
                      staticClass: "vacancy-detail__hero-title",
                      attrs: { tag: "p" },
                    },
                    [_vm._v(_vm._s(_vm.text.filters.specialization))]
                  ),
                  _vm._v(" "),
                  _c(
                    "z-caption",
                    {
                      staticClass: "vacancy-detail__hero-text",
                      attrs: { tag: "p" },
                    },
                    [_vm._v(_vm._s(_vm.vacancyData.specialization.value))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "vacancy-detail__hero-action-container" }, [
          _c(
            "a",
            {
              staticClass: "vacancy-detail__hero-link",
              attrs: {
                href:
                  "/" +
                  _vm.$root.lang +
                  "/career/seekers?position=" +
                  _vm.vacancyData.name +
                  "&id=" +
                  _vm.vacancyData.hfid.value,
              },
            },
            [
              _c(
                "z-button",
                {
                  staticClass: "vacancy-detail__hero-action-button",
                  scopedSlots: _vm._u([
                    {
                      key: "right",
                      fn: function () {
                        return [
                          _c("z-icon", {
                            attrs: {
                              name: "arrow_long",
                              dir: "right",
                              width: "32",
                              height: "20",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [_vm._v("Откликнуться на вакансию\n                        ")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.vacancyData.responsibilities && _vm.vacancyData.responsibilities.value
        ? _c(
            "div",
            { staticClass: "vacancy-detail__detail" },
            [
              _c(
                "z-caption",
                {
                  staticClass: "vacancy-detail__detail-title",
                  attrs: { tag: "h2" },
                },
                [_vm._v("Обязанности")]
              ),
              _vm._v(" "),
              _c("vue-raw", {
                staticClass: "html-content",
                attrs: { raw: _vm.vacancyData.responsibilities.value },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.vacancyData.requirements && _vm.vacancyData.requirements.value
        ? _c(
            "div",
            { staticClass: "vacancy-detail__detail" },
            [
              _c(
                "z-caption",
                {
                  staticClass: "vacancy-detail__detail-title",
                  attrs: { tag: "h2" },
                },
                [_vm._v("Требования")]
              ),
              _vm._v(" "),
              _c("vue-raw", {
                staticClass: "html-content",
                attrs: { raw: _vm.vacancyData.requirements.value },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.vacancyData.conditions && _vm.vacancyData.conditions.value
        ? _c(
            "div",
            { staticClass: "vacancy-detail__detail" },
            [
              _c(
                "z-caption",
                {
                  staticClass: "vacancy-detail__detail-title",
                  attrs: { tag: "h2" },
                },
                [_vm._v("Условия")]
              ),
              _vm._v(" "),
              _c("vue-raw", {
                staticClass: "html-content",
                attrs: { raw: _vm.vacancyData.conditions.value },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      (_vm.vacancyData.request_email && _vm.vacancyData.request_email.value) ||
      (_vm.vacancyData.request_phone && _vm.vacancyData.request_phone.value)
        ? _c("div", { staticClass: "vacancy-detail__hero" }, [
            _c("div", { staticClass: "vacancy-detail__hero-item-container" }, [
              _vm.vacancyData.request_email &&
              _vm.vacancyData.request_email.value
                ? _c(
                    "div",
                    { staticClass: "vacancy-detail__hero-item" },
                    [
                      _c(
                        "z-caption",
                        {
                          staticClass: "vacancy-detail__hero-title",
                          attrs: { tag: "p" },
                        },
                        [_vm._v(_vm._s(_vm.text.recuter_email))]
                      ),
                      _vm._v(" "),
                      _c(
                        "z-caption",
                        {
                          staticClass: "vacancy-detail__hero-text",
                          attrs: { tag: "p" },
                        },
                        [
                          _c(
                            "z-link",
                            {
                              staticClass: "communication-item__link",
                              attrs: {
                                href:
                                  "mailto:" +
                                  _vm.vacancyData.request_email.value,
                                inline: false,
                                icon: "mail",
                                "icon-width": "20",
                                "icon-height": "20",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.vacancyData.request_email.value) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.vacancyData.request_phone &&
              _vm.vacancyData.request_phone.value
                ? _c(
                    "div",
                    { staticClass: "vacancy-detail__hero-item" },
                    [
                      _c(
                        "z-caption",
                        {
                          staticClass: "vacancy-detail__hero-title",
                          attrs: { tag: "p" },
                        },
                        [_vm._v(_vm._s(_vm.text.recuter_phone))]
                      ),
                      _vm._v(" "),
                      _c(
                        "z-caption",
                        {
                          staticClass: "vacancy-detail__hero-text",
                          attrs: { tag: "p" },
                        },
                        [
                          _c(
                            "z-link",
                            {
                              staticClass: "communication-item__link",
                              attrs: {
                                href:
                                  "tel:" + _vm.vacancyData.request_phone.phone,
                                icon: "phone",
                                "icon-width": "20",
                                "icon-height": "20",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.vacancyData.request_phone.value) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }